/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-runloop */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { later } from '@ember/runloop';
import { action, computed } from '@ember/object';
import { sort } from '@ember/object/computed';
import { tablePrintCss } from 'linced-app/utils/table';
import {
  cleanExcelSheetName,
  cleanFileName,
  uniqueSheetName,
} from '@linc-technologies/linced-common/utils/file-names';
import moment from 'moment';
import { naturalSort } from '@linc-technologies/linced-common/utils/sorting';

export default class CurrentNewClassController extends Controller {
  @service
  excel;

  title = 'Current to New Class Lists';
  year = moment().format('YYYY');

  @sort('model.currHomerooms', naturalSort('name'))
  sortedCurrentHomerooms;

  @computed('model.newHomerooms.[]')
  get learnerToNewClass() {
    return this.model.newHomerooms.reduce((map, room) => {
      room.currentLearners.forEach((learner) => {
        map[learner.personId] = room.name;
      });

      return map;
    }, {});
  }

  @action
  downloadFullXlsx() {
    let sheets = [];
    let sheetNames = [];

    this.sortedCurrentHomerooms.forEach((homeroom) => {
      let sheetName = uniqueSheetName(
        cleanExcelSheetName(homeroom.name),
        sheetNames,
      );
      sheetNames.push(sheetName);

      sheets.push({
        name: sheetName,
        data: this.getExportData(homeroom),
      });
    });

    let fileName = `${this.title} ${moment().format('YYYY-MM-DD')}.xlsx`;

    this.excel.export(sheets, {
      multiSheet: true,
      fileName: cleanFileName(fileName),
    });
  }

  @action
  print() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );
    let classLists = document.querySelectorAll('.class-list');
    let content = tablePrintCss;

    content += `<style>.table-tools button { display: none; }</style>`;

    classLists.forEach((classList, index) => {
      if (index !== 0) {
        content += `<div style="page-break-before: always"></div>`;
      }

      content += classList.outerHTML;
    });

    printer.document.body.innerHTML = content;

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }

  getExportData(homeroom) {
    let data = [];

    // Class info
    data.push(
      [`${homeroom.name}`],
      ['New Classes:'],
      [`${homeroom.staffNames}`],
    );

    // Column headers
    data.push([
      'Family Name',
      'First Name',
      'Current Year Level',
      `${parseInt(this.year) + 1} Class`,
    ]);

    // Data
    homeroom.currentLearners.forEach((learner) => {
      data.push([
        learner.person.lastName,
        learner.person.firstName,
        learner.person.currentYearLevel,
        this.learnerToNewClass[learner.personId],
      ]);
    });

    return data;
  }
}
